import React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const BackpackCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const backpack = useWatch({ name: 'backpack_states' });
  const filterCount = Array.isArray(backpack) && backpack.length > 0 ? 1 : 0;
  useFilterCount('backpack', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="backpackFilter"
      triggerValue={t('events:backpack')}
      {...props}
    >
      <CheckboxCustomFilter
        control={control}
        isMulti
        label={t('events:backpack')}
        name="backpack_states"
        options={EVENT_ENUMS.ACCESSORIES.BACKPACK.raw}
      />
    </CustomFilterPopover>
  );
};
